import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import GestionaleOnboarding from "../components/GestionaleOnboarding";
import BrandMark from "../components/BrandMark";
import {
  Building2, Wine, Calculator, Container, Stamp, TrendingUp,
  Users, BarChart3, ArrowRight, Lock, LogOut, Download, Sparkles,
  CheckCircle2, ChevronRight, Workflow, Globe, FileText,
  Award, QrCode, Thermometer, ShieldAlert, Beaker, MapPin,
  Calendar, Box, Banknote, Tag, Leaf, ClipboardCheck,
  Package, Gift, ChefHat, Layers, Boxes, Truck,
} from "lucide-react";

const PDF_URL = `${process.env.REACT_APP_BACKEND_URL}/api/gestionale/pitch.pdf`;

const MODULES = [
  { n: "01", icon: Building2, slug: "supplier-onboarding", title: "Supplier Onboarding", sub: "Attivare nuovi fornitori europei", status: "live", statusLabel: "LIVE", href: "/gestionale/suppliers",
    points: ["Anagrafica · P.IVA · referenti", "Contratti · MOQ · Incoterm", "Cataloghi & certificazioni"], kpi: "Fornitori attivi · Tempo onboarding" },
  { n: "02", icon: Wine, slug: "compliance", title: "Product Compliance Hub", sub: "SKU idonei per il Brasile", status: "live", statusLabel: "AI SCANNER LIVE", href: "/admin/imports",
    points: ["MAPA category · NCM · alcohol %", "Document repository PDF", "Workflow NEW → COMMERCIAL ACTIVE"], kpi: "SKU approvati · Tempo approvazione" },
  { n: "03", icon: Calculator, slug: "quotation", title: "Quotation & Deal Desk", sub: "Prezzi, costi, margini", status: "live", statusLabel: "LIVE", href: "/gestionale/quotations",
    points: ["Cost Sim EXW/FOB/Freight", "Margin calculator", "Storico offerte"], kpi: "Margine per SKU · Conv. rate offerte" },
  { n: "04", icon: Container, slug: "container", title: "Container & Shipping", sub: "Consolidamento multi-fornitore", status: "live", statusLabel: "LIVE", href: "/gestionale/containers",
    points: ["CBM · peso · temperatura", "Vessel tracking · ETD/ETA", "Export docs (CI · PL · BL · COO)"], kpi: "Fill rate · Freight cost/unit" },
  { n: "05", icon: Stamp, slug: "mapa-workflow", title: "MAPA Workflow", sub: "Compliance importazione Brasile", status: "live", statusLabel: "LIVE", href: "/gestionale/mapa-cases",
    points: ["Dossier LI / SISCOMEX", "Broker review · MAPA analysis", "Alert exigências"], kpi: "Giorni approvazione · Pratiche aperte" },
  { n: "06", icon: TrendingUp, slug: "commission", title: "Commission Engine", sub: "Calcolo commissioni", status: "live", statusLabel: "LIVE", href: "/gestionale/commissions",
    points: ["Formula FOB × % o margine", "Report fornitore/cliente/container", "Trimestrale"], kpi: "Commissioni mensili · Margine totale" },
  { n: "07", icon: Users, slug: "crm-brazil", title: "CRM B2B Brazil", sub: "Importatori · Distributori · Horeca · Retail", status: "live", statusLabel: "LIVE", href: "/gestionale/crm-leads",
    points: ["Pipeline LEAD → REORDER", "Campionature · Meeting", "Storico ordini"], kpi: "Conversion rate · Riordini" },
  { n: "08", icon: BarChart3, slug: "dashboard-management", title: "Management Dashboard", sub: "Cockpit operations + finance", status: "live", statusLabel: "BASE LIVE", href: "/admin",
    points: ["Procurement · Compliance · Logistics", "Sales · Finance", "Exposure EUR/BRL"], kpi: "KPI cross-funzionali real-time" },
];

const WINE_MODULES = [
  { n: "W1", icon: Wine, slug: "wine-cellar", title: "Cellar Inventory", sub: "Cantina virtuale multi-fornitore", status: "roadmap",
    points: ["Stock per cantina · annata · DOC/DOCG", "Allocazione lotti per container", "Riserve & magazzini europei"], kpi: "Bottiglie disponibili · Rotazione" },
  { n: "W2", icon: Beaker, slug: "wine-lab", title: "Wine Lab Test Manager", sub: "Analisi chimica MAPA-ready", status: "roadmap",
    points: ["pH · acidità · solfiti · zuccheri", "Lab accreditati EU/BR", "COA workflow auto-link a SKU"], kpi: "Test passati · Tempo refertazione" },
  { n: "W3", icon: Calendar, slug: "wine-vintage", title: "Vintage & Allocation", sub: "Tracciamento annate & riserve", status: "roadmap",
    points: ["Storico annate per cantina", "Allocation futura · pre-ordini", "Limited release tracking"], kpi: "Annate gestite · Allocazione %" },
  { n: "W4", icon: Award, slug: "wine-awards", title: "Awards & Certifications", sub: "Punteggi & riconoscimenti", status: "roadmap",
    points: ["Gambero Rosso · Decanter · Suckling", "Bio · biodinamico · vegan", "Premium positioning ADDUMA"], kpi: "SKU premiati · Score medio" },
  { n: "W5", icon: Sparkles, slug: "wine-sommelier", title: "AI Sommelier Notes", sub: "Note di degustazione automatiche", status: "roadmap",
    points: ["GPT-5.2 IT/EN/PT", "Pairing cucina brasiliana", "Auto-traduzione importatore"], kpi: "Note generate · Engagement" },
  { n: "W6", icon: QrCode, slug: "wine-authenticity", title: "Bottle Authenticity & QR", sub: "Anti-counterfeit & tracciabilità", status: "roadmap",
    points: ["QR univoco bottiglia/pallet", "NFT seal high-end", "Story-tag bilingue IT/PT"], kpi: "Bottiglie verificate · Frodi rilevate" },
];

const FOOD_MODULES = [
  { n: "F1", icon: Thermometer, slug: "food-coldchain", title: "Cold Chain Monitor", sub: "Catena del freddo container", status: "roadmap",
    points: ["Sensori IoT temperatura/umidità", "Alert deviazione real-time", "Report MAPA / sanitario BR"], kpi: "Container conformi · Eccezioni" },
  { n: "F2", icon: ShieldAlert, slug: "food-haccp", title: "HACCP Compliance", sub: "Sicurezza alimentare ANVISA", status: "roadmap",
    points: ["Punti critici per categoria", "Documentazione audit-ready", "Sync ANVISA / MAPA"], kpi: "Audit superati · NC" },
  { n: "F3", icon: Leaf, slug: "food-dop", title: "DOP / IGP / STG Tracker", sub: "Specialità tradizionali italiane", status: "roadmap",
    points: ["Indicazioni geografiche protette", "Disciplinari produzione", "Storytelling premium"], kpi: "DOP attive · Coverage regioni" },
  { n: "F4", icon: ClipboardCheck, slug: "food-shelflife", title: "Shelf Life & Lotti", sub: "Scadenze e tracciabilità lotti", status: "roadmap",
    points: ["Best-before per SKU", "Lotti deperibili priorità", "Alert shelf-life critica"], kpi: "Lotti in scadenza · Rotazione" },
  { n: "F5", icon: MapPin, slug: "food-allergens", title: "Allergeni & Traceability", sub: "Etichettatura BR-compliant", status: "roadmap",
    points: ["Allergeni ANVISA RDC 26/2015", "Etichetta PT-BR auto-generata", "Traceability lotto → ingrediente"], kpi: "SKU labelizzati · Errori" },
  { n: "F6", icon: ChefHat, slug: "food-recipes", title: "Recipe & Pairing Hub", sub: "Box ricetta + pairing vino/food", status: "live", statusLabel: "B2C LIVE", href: "/ai-ricette",
    points: ["AI recipes integrate", "Box dedicate per ricetta", "Sommelier AI per pairing"], kpi: "Ricette generate · Conv. box" },
];

const FOODBOX_MODULES = [
  { n: "B1", icon: Package, slug: "foodbox-builder", title: "Food Box Builder", sub: "Compositore box gourmet B2B", status: "live", statusLabel: "BASE LIVE", href: "/admin",
    points: ["Drag & drop SKU su box template", "Calcolo peso · CBM · costo box", "Versioning box stagionali"], kpi: "Box attive · SKU per box" },
  { n: "B2", icon: Calculator, slug: "foodbox-pricing", title: "Box Pricing & Margin", sub: "Margine bundle gourmet", status: "roadmap",
    points: ["Costo somma SKU + packaging", "Margine target retail/Horeca", "Promo bundle wine + food"], kpi: "Margine medio box · Sell-through" },
  { n: "B3", icon: Boxes, slug: "foodbox-lots", title: "Lotti Food Export-Ready", sub: "Lotti food consolidati per BR", status: "live", statusLabel: "BASE LIVE", href: "/admin/imports",
    points: ["Lotti CSV con quantità · pallet", "Status approval automatico admin", "Consolidamento per container"], kpi: "Lotti attivi · Pallet/container" },
  { n: "B4", icon: Gift, slug: "foodbox-gift", title: "Hamper & Corporate Gifts", sub: "Regali aziendali & private label", status: "roadmap",
    points: ["White-label box per cliente BR", "Personalizzazione gift card", "Hamper Natale / Pasqua"], kpi: "Hamper venduti · Order value medio" },
  { n: "B5", icon: Layers, slug: "foodbox-bundle", title: "Cross-sell Wine + Food", sub: "Bundle vino + delicatessen", status: "roadmap",
    points: ["Pairing automatico Box+vino", "Margine bundle vs singolo SKU", "Upsell premium tier ADDUMA"], kpi: "Bundle conversion · Uplift €" },
  { n: "B6", icon: Truck, slug: "foodbox-fulfillment", title: "Box Fulfillment Tracking", sub: "Allestimento e spedizione box", status: "roadmap",
    points: ["Picking list per centro packaging", "Status preparato → spedito", "Tracking ultimo miglio BR"], kpi: "Box/giorno · Tempo prep" },
];

const CROSS_MODULES = [
  { n: "X1", icon: Container, slug: "cross-dta", title: "DTA Brasil Connector", sub: "Integrazione partner logistico", status: "roadmap",
    points: ["Sync booking · ETD · ETA", "Documenti dogana auto-export", "Tracking real-time vessel"], kpi: "Container DTA · Lead time" },
  { n: "X2", icon: Stamp, slug: "cross-adduma", title: "ADDUMA Compliance Bridge", sub: "Connector partner compliance BR", status: "roadmap",
    points: ["Push automatico dossier MAPA", "Status pratiche LI/SISCOMEX", "Alert exigências bidirezionale"], kpi: "Pratiche ADDUMA · Tempo medio" },
  { n: "X3", icon: Tag, slug: "cross-pricing", title: "Pricing Tier Manager", sub: "Listini differenziati per cliente", status: "roadmap",
    points: ["Tier importatore/distributore/Horeca", "Sconti volume · campagne", "Margine target per canale"], kpi: "Margine medio per tier" },
  { n: "X4", icon: Box, slug: "cross-samples", title: "Sample & Tasting Manager", sub: "Campionature & eventi BR", status: "roadmap",
    points: ["Storico campioni inviati", "Eventi tasting in Brasile", "Conversion sample → PO"], kpi: "Sample → ordine · Eventi" },
  { n: "X5", icon: Banknote, slug: "cross-fx", title: "FX Hedging EUR↔BRL", sub: "Esposizione cambio + copertura", status: "roadmap",
    points: ["Esposizione real-time", "Forward contract simulator", "Margin protection"], kpi: "Exposure netta · Hedge ratio" },
  { n: "X6", icon: ShieldAlert, slug: "cross-brand", title: "Brand Protection", sub: "Tutela brand italiani in Brasile", status: "roadmap",
    points: ["Marchi registrati · INPI watch", "Anti italian-sounding monitoring", "Legal escalation pipeline"], kpi: "Marchi monitorati · Alert mensili" },
];

const STATUS = {
  live: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-300", label: "LIVE" },
  roadmap: { bg: "bg-stone-50", text: "text-stone-500", border: "border-stone-300", label: "ROADMAP" },
};

function StatusPill({ status, label }) {
  const cfg = STATUS[status] || STATUS.roadmap;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-[9px] uppercase tracking-[0.2em] font-bold rounded-sm border ${cfg.bg} ${cfg.text} ${cfg.border}`}>
      {status === "live" && <CheckCircle2 className="h-2.5 w-2.5" />}
      {label || cfg.label}
    </span>
  );
}

function ModuleCard({ m }) {
  const isLive = m.status === "live";
  const Inner = (
    <article
      data-testid={`gest-module-${m.slug}`}
      className={`relative bg-white rounded-sm p-5 group h-full flex flex-col transition-all border shadow-sm
        ${isLive ? "border-[#C9A961]/50 hover:border-[#C9A961] hover:shadow-md" : "border-stone-200 hover:border-stone-400 hover:shadow-md"}`}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-start gap-3">
          <div className="text-[#C9A961]/50 group-hover:text-[#C9A961] transition-colors editorial-heading text-3xl leading-none font-light shrink-0">{m.n}</div>
          <m.icon className={`h-5 w-5 mt-1 ${isLive ? "text-[#C9A961]" : "text-stone-400"}`} />
        </div>
        <StatusPill status={m.status} label={m.statusLabel} />
      </div>
      <h3 className="editorial-heading text-lg text-stone-900 leading-tight">{m.title}</h3>
      <p className="text-xs text-stone-500 mt-1.5">{m.sub}</p>
      <ul className="mt-3 space-y-1.5 flex-1">
        {m.points.map((p, j) => (
          <li key={j} className="flex items-start gap-2 text-xs text-stone-700 leading-relaxed">
            <ChevronRight className="h-3 w-3 text-[#C9A961] mt-0.5 shrink-0" />
            <span>{p}</span>
          </li>
        ))}
      </ul>
      <div className="mt-3 pt-3 border-t border-stone-100 flex items-center justify-between gap-2">
        <span className="text-[9px] uppercase tracking-[0.2em] text-stone-400 truncate">{m.kpi}</span>
        <span className={`text-[10px] uppercase tracking-wider font-bold flex items-center gap-1 shrink-0 ${isLive ? "text-[#A88A4A]" : "text-stone-400"}`}>
          {isLive ? "Apri" : "Soon"} <ArrowRight className="h-3 w-3" />
        </span>
      </div>
    </article>
  );
  return isLive && m.href
    ? <Link to={m.href}>{Inner}</Link>
    : <Link to={`/gestionale/modulo/${m.slug}`}>{Inner}</Link>;
}

function SectionHeader({ icon: Icon, eyebrow, title, italicTail }) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2.5 mb-2">
        <Icon className="h-4 w-4 text-[#C9A961]" />
        <div className="text-[10px] uppercase tracking-[0.35em] text-[#A88A4A] font-bold">{eyebrow}</div>
      </div>
      <h2 className="editorial-heading text-2xl md:text-3xl text-stone-900 leading-tight">
        {title} {italicTail && <span className="italic text-[#A88A4A]">{italicTail}</span>}
      </h2>
    </div>
  );
}

export default function GestionaleDashboard() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  if (!user || !["super_admin", "admin_broker", "buyer"].includes(user.role)) {
    return (
      <div className="min-h-screen bg-[#faf7f0] text-stone-900 flex items-center justify-center p-6">
        <div className="max-w-sm text-center space-y-4">
          <Lock className="h-10 w-10 text-[#C9A961] mx-auto" />
          <h2 className="editorial-heading text-2xl">Accesso riservato</h2>
          <p className="text-sm text-stone-500">Devi accedere con un account autorizzato per usare il gestionale.</p>
          <Link to="/gestionale" className="inline-block px-6 py-3 bg-[#C9A961] text-white font-bold uppercase tracking-[0.2em] text-xs hover:bg-[#A88A4A]">
            Vai al login
          </Link>
        </div>
      </div>
    );
  }

  const allModules = [...MODULES, ...WINE_MODULES, ...FOOD_MODULES, ...FOODBOX_MODULES, ...CROSS_MODULES];
  const liveAll = allModules.filter(m => m.status === "live").length;
  const totalModules = allModules.length;

  return (
    <div data-testid="gestionale-dashboard-page" className="min-h-screen bg-gradient-to-b from-[#faf7f0] via-[#f7f1e3] to-[#f5efe1] text-stone-900">
      {/* Top bar */}
      <header className="border-b border-[#C9A961]/30 bg-white/80 backdrop-blur sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4 flex items-center justify-between gap-4">
          <BrandMark size="md" variant="dark" />
          <div className="flex items-center gap-2 md:gap-3">
            <Link to="/gestionale/pitch" data-testid="topbar-pitch" className="hidden md:inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-stone-600 hover:text-[#C9A961] px-3 py-2">
              <FileText className="h-3 w-3" /> Pitch
            </Link>
            <a href={PDF_URL} target="_blank" rel="noopener noreferrer" data-testid="topbar-pdf" className="hidden md:inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-[#A88A4A] hover:text-white hover:bg-[#C9A961] px-3 py-2 border border-[#C9A961]/50">
              <Download className="h-3 w-3" /> PDF
            </a>
            <Link to="/admin" data-testid="topbar-admin" className="hidden lg:inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-stone-600 hover:text-stone-900 px-3 py-2 border border-stone-300">
              Admin Amazonico
            </Link>
            <button
              data-testid="topbar-logout"
              onClick={() => { logout(); nav("/gestionale"); }}
              className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] bg-stone-100 hover:bg-red-50 hover:text-red-700 text-stone-700 px-3 py-2 border border-stone-300"
            >
              <LogOut className="h-3 w-3" /> Esci
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10 md:py-14">
        {/* Hero / Welcome */}
        <div className="grid md:grid-cols-[1fr_auto] gap-8 items-end mb-10 pb-10 border-b border-[#C9A961]/30">
          <div>
            <BrandMark size="xl" compact variant="dark" linked={false} className="mb-6" />
            <div className="text-[10px] uppercase tracking-[0.4em] text-[#A88A4A] font-bold mb-3">Console operativa · Italia → Brasile</div>
            <h1 className="editorial-heading text-4xl md:text-6xl leading-[1.05] text-stone-900">
              Bentornato, <span className="italic text-[#A88A4A]">{user.name?.split(" ")[0] || "Operatore"}.</span>
            </h1>
            <p className="text-stone-500 mt-3 text-sm">
              Connesso come <span className="text-stone-800 font-semibold">{user.email}</span> · ruolo <span className="text-[#A88A4A] uppercase tracking-wider font-bold">{user.role}</span>
            </p>
          </div>
          <div className="grid grid-cols-2 gap-6 md:gap-10 text-right">
            <div>
              <div className="editorial-heading text-4xl md:text-5xl text-[#C9A961] leading-none">{liveAll}<span className="text-2xl text-stone-400">/{totalModules}</span></div>
              <div className="text-[9px] uppercase tracking-[0.3em] text-stone-500 mt-2">Moduli operativi</div>
            </div>
            <div>
              <div className="editorial-heading text-4xl md:text-5xl text-[#C9A961] leading-none">21</div>
              <div className="text-[9px] uppercase tracking-[0.3em] text-stone-500 mt-2">Campi MAPA AI</div>
            </div>
          </div>
        </div>

        {/* Setup Wizard */}
        <GestionaleOnboarding />

        {/* Architettura strip */}
        <div className="mb-12 bg-white border border-stone-200 rounded-sm p-5 shadow-sm">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#A88A4A] font-bold mb-3 flex items-center gap-2">
            <Workflow className="h-3 w-3" /> Architettura · Pipeline operativa
          </div>
          <div className="flex flex-wrap items-center gap-2 text-[10px] uppercase tracking-[0.18em] text-stone-700">
            {["Fornitori EU", "Supplier Portal", "Compliance Hub", "Quotation", "Shipping", "MAPA Workflow", "Importatore BR", "Clienti B2B"].map((s, i) => (
              <React.Fragment key={i}>
                <span className="px-2.5 py-1 border border-[#C9A961]/40 bg-[#C9A961]/5 text-stone-800 font-semibold">{s}</span>
                {i < 7 && <ChevronRight className="h-3 w-3 text-[#C9A961]" />}
              </React.Fragment>
            ))}
          </div>
          <div className="mt-3 pt-3 border-t border-stone-100 flex flex-wrap items-center gap-3 text-[9px] uppercase tracking-[0.2em] text-stone-500">
            <span className="text-[#A88A4A] font-bold">DTA BRASIL</span><span>logistica</span>
            <span className="h-px w-4 bg-stone-300" />
            <span className="text-[#A88A4A] font-bold">ADDUMA BRASIL</span><span>compliance</span>
            <span className="h-px w-4 bg-stone-300" />
            <span className="text-[#A88A4A] font-bold">TRINACRIA · DORA GOURMET</span><span>importatori</span>
            <span className="h-px w-4 bg-stone-300" />
            <span className="text-[#A88A4A] font-bold">GRUPPO ALIMENTARE ITALIANO</span><span>distribuzione</span>
          </div>
        </div>

        {/* SEZIONE 1: 8 MODULI ORIZZONTALI */}
        <SectionHeader icon={Layers} eyebrow="Le 8 funzioni · Operations core" title="Otto moduli." italicTail="Una console." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {MODULES.map((m) => <ModuleCard key={m.n} m={m} />)}
        </div>

        {/* SEZIONE 2: WINE OPERATIONS */}
        <div className="mt-16">
          <SectionHeader icon={Wine} eyebrow="Wine Operations · Verticale vino" title="Il vino italiano," italicTail="curato fino al calice brasiliano." />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {WINE_MODULES.map((m) => <ModuleCard key={m.n} m={m} />)}
          </div>
        </div>

        {/* SEZIONE 3: FOOD OPERATIONS */}
        <div className="mt-16">
          <SectionHeader icon={Leaf} eyebrow="Food Operations · Verticale alimentare" title="Salumi, formaggi, oli, pasta." italicTail="Conformi e tracciati." />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {FOOD_MODULES.map((m) => <ModuleCard key={m.n} m={m} />)}
          </div>
        </div>

        {/* SEZIONE 4: FOOD BOX & LOTTI FOOD */}
        <div className="mt-16">
          <SectionHeader icon={Package} eyebrow="Food Box & Lotti · Bundle gourmet B2B" title="Box curate, lotti consolidati." italicTail="Pronti per l'export." />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {FOODBOX_MODULES.map((m) => <ModuleCard key={m.n} m={m} />)}
          </div>
        </div>

        {/* SEZIONE 5: CROSS / PARTNER ENGINE */}
        <div className="mt-16">
          <SectionHeader icon={Workflow} eyebrow="Partner & Cross Engine · DTA · ADDUMA" title="Connessi ai" italicTail="partner brasiliani, protetti sul cambio." />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {CROSS_MODULES.map((m) => <ModuleCard key={m.n} m={m} />)}
          </div>
        </div>

        {/* Footer info */}
        <div className="mt-16 pt-6 border-t border-stone-200 flex items-center justify-between flex-wrap gap-4 text-[10px] uppercase tracking-[0.25em] text-stone-400">
          <span className="flex items-center gap-1.5"><Globe className="h-3 w-3" /> Italia → Brasile</span>
          <span>Amazonico 3000 · Gestionale B2B · Tutti gli accessi tracciati</span>
        </div>
      </div>
    </div>
  );
}
